require('./RAInformativeBox.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

class RAInformativeBox extends React.Component {
    render() {
        const { title, children } = this.props;
        return (
            <div className="ra-informative-box">
                <div className="ra-informative-box__title">
                    <i className="icon icon-informacion ra-informative-box__icon" />
                    {title}
                </div>
                <div className="ra-informative-box__content">{children}</div>
            </div>
        );
    }
}

RAInformativeBox.propTypes = {
    children: PropTypes.any.isRequired,
    title: PropTypes.string.isRequired,
};

module.exports = RAInformativeBox;
